import React, { useEffect, useState } from 'react';
import { Bell, X } from 'lucide-react';

const NotificationToast = ({ notifications, onDismiss }) => {
  return (
    <div className="fixed bottom-6 right-6 z-50 space-y-3">
      {notifications.map((notif) => (
        <div
          key={notif.id}
          className="bg-gradient-to-r from-cyan-500 to-sky-600 text-white rounded-lg shadow-lg p-4 flex items-start space-x-3 min-w-[320px] max-w-md animate-slide-in"
        >
          <Bell className="w-5 h-5 mt-0.5 animate-pulse" />
          <div className="flex-1">
            <p className="font-semibold text-sm">{notif.title}</p>
            <p className="text-xs text-cyan-100 mt-1">{notif.message}</p>
          </div>
          <button
            onClick={() => onDismiss(notif.id)}
            className="text-white/80 hover:text-white transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default NotificationToast;